import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import Header from "../Components/Headers";
import OrderDetails from "../Components/OrderDetails";
import Dashboard from "./Pages/Dashboard";
import Members from "./Pages/Members";
import POSBooking from "./Pages/POSBooking";
import Transaction from "./Pages/Transaction";
import Report from "./Pages/Report";
import CopyrightFooter from "../Components/CopyrightFooter";

function POS() {
  const { url } = useRouteMatch();
  return (
    <>
      <Header Layout="POS" />
      <main className="container-fluid pt-2">
        <Switch>
          <Route path={url} exact component={Dashboard} />
          <Route path={url + `/POSBooking`} component={POSBooking} />
          <Route path={url + `/ViewMembers`} exact component={Members} />
          <Route path={url + `/Report`} exact component={Report} />
          <Route path={url + `/Transaction`} exact component={Transaction} />
          <Route path={url + `/ViewOrders`} exact>
            <React.Fragment>
              <p className="divider mb-12 m-0">Bar Orders</p>
              <OrderDetails display="bar" />
              <p className="divider mb-12 m-1">Kitchen Orders</p>
              <OrderDetails display="kitchen" />
            </React.Fragment>
          </Route>
        </Switch>
      </main>
      <CopyrightFooter />
    </>
  );
}
export default React.memo(POS);
